import { AgioPaymentsModels } from '../contants/AgioPaymentsModels';
import { AgioPaymentsPercentages, MINIMUM_PERIOD_TO_START_SAVING_PLAN, SavingPlanPaymentIntervals } from '../contants';
import { DataItem, Depot, NextPossibleDate, PaymentAccount, PaymentMethod, SavingsPlanPaymentInterval, SpPerformanceData } from '../models';
import { AddDepotRequest, AddSavingsPlanRequest, UpdateDepotRequest } from '../requests';
import { HttpHeader } from '../utils/HttpHeader';
import { HttpRequester } from '../utils/HttpRequester';
import { Urls } from "../utils/Urls";
import { TokenService } from './TokenService';
import moment from 'moment';
import { LAST_POSSIBLE_DATE_FOR_FIRST, LAST_POSSIBLE_DATE_FOR_HALF } from '../contants/Constants';

export class AddDepotService {
    private static links = Urls.URLS();
    private static requester = HttpRequester.httpRequester();
    private static headers = new HttpHeader();
    public static async saveTheDepot(request:AddDepotRequest):Promise<any>{
        const url = this.links.addDepot();
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        if(request.interval_amount){
            const intervalIds = await this.getIntervalIds();
            intervalIds.forEach(interval=>{
                if(interval.name_translation_key == SavingPlanPaymentIntervals.interval_monthly){
                    request.interval_id = interval.id;
                }
            })
        }
        let res = await this.requester.post(url,this.headers,request);
        return res;
    }
    public static async saveTheSavingPlan(depotId:number,request:AddSavingsPlanRequest):Promise<any>{
        const url = this.links.addSavingPlan(depotId);
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        if(request.interval_amount){
            const intervalIds = await this.getIntervalIds();
            intervalIds.forEach(interval=>{
                if(interval.name_translation_key == SavingPlanPaymentIntervals.interval_monthly){
                    request.interval_id = interval.id;
                }
            })
        }
        let res = await this.requester.put(url,this.headers,request);
        return res;
    }
    public static calculateChartData(nbrOfYears:number,monthlySavings:number,returnsPercentage:number,totalAgio:number,agioPaymentModel:AgioPaymentsModels):SpPerformanceData{
        let data : SpPerformanceData = {savingsData:[],agioData:[],};
        let agioPaymentPercentage = AgioPaymentsPercentages.SeventyFive;
        let agioData : DataItem[] = [];
        if(agioPaymentModel == AgioPaymentsModels.onetime){
            agioData.push({
                year:1,
                value:totalAgio
            })
        }
        else{
            let yearlyPayment = ((monthlySavings/100)*agioPaymentPercentage)*12;
            let numOfYear = Math.ceil(totalAgio/(yearlyPayment));
            for (let index = 1; index <= numOfYear; index++) {
                
                    let  payed = yearlyPayment*(index-1);
                    let rest = totalAgio - payed;
                    if(rest>yearlyPayment)
                    {
                        agioData.push({year:index,value:yearlyPayment})
                    }
                    else
                    {
                        agioData.push({year:index,value:rest})
                    }
                
                
                
            }
        }
        data.agioData = agioData;
        let savingData : DataItem[] = [];
        for (let index = 1; index <= nbrOfYears; index++) {
            
            let prev = 0;
            if(index>1)
                prev = savingData[index-2].value;
           
            const element = {year:index,value:monthlySavings*12+prev}
            savingData.push(element);
        }
        
        data.savingsData = savingData;
        let returnsData  : DataItem[] = [];
        for (let index = 1; index <= nbrOfYears; index++) {
            let prev = 0;
            if(index>1)
                prev = returnsData[index-2].value;
            
            let brute = monthlySavings*12+prev;
            if(index<=agioData.length && agioPaymentModel != AgioPaymentsModels.onetime)
            {
            
                brute = brute - agioData[index-1].value;
            }
            const returns = brute + (brute/100)*returnsPercentage;
            const element = {year:index,value:returns}
            returnsData.push(element);
        }
        data.returnsData = returnsData;
        return data;
    }
    public static  calculateChartDataBasedOnTransactionFee(numberOfYears:number,monthlySaving:number,percentage:number,feePerTransaction:number):SpPerformanceData{
        let data : SpPerformanceData = {savingsData:[],agioData:[],returnsData:[]};
        let agioData : DataItem[] = [];
       
        let yearlyPayment = ((monthlySaving*12)/100)*(feePerTransaction);
        
        for (let index = 0; index < numberOfYears; index++) {  
            
            agioData.push({year:index+1,value:(yearlyPayment*(index+1))})
        }
        data.agioData = agioData;
        let savingData : DataItem[] = [];
        
        for (let index = 0; index < numberOfYears; index++) {
            let prev = 0;
            if(index>0)
                prev = savingData[index-1].value;
           
            const element = {year:index+1,value:monthlySaving*12+prev}
            savingData.push(element);
        }
        
        data.savingsData = savingData;
       
        let returnsData : DataItem[] = [];
        
        for (let index = 0; index < numberOfYears; index++) {
            let prev = 0;
            
           if(index>0)
                prev = returnsData[index-1].value;
            
            let brute = monthlySaving*12+prev;
            brute = brute - yearlyPayment;
            
            const returns = brute + (brute/100)*percentage;
            const element = {year:index+1,value:returns};
            returnsData.push(element);
        }
        data.returnsData = returnsData;
        return data;
    }
    public static calculateSavingsPlanDataBasedOninitialValuesBasedOnTransactionFee(initialFee:number,initialDeposit:number,initialPerformance:number,monthlySaving:number,numberOfMonth:number,feePerTransaction:number,percentage:number):SpPerformanceData{
        let data : SpPerformanceData = {savingsData:[],agioData:[],returnsData:[]};
        let agioData : DataItem[] = []; 
        agioData.push({month:0,value:parseFloat(initialFee.toString())});
        let lastMonths = numberOfMonth % 12;
        let agioSum = initialFee
        for (let index = 0; index < numberOfMonth; index++) {  
            let paymentToAdd = monthlySaving/100*feePerTransaction;
            
            agioSum+=paymentToAdd;
            agioData.push({month:index+1,value:agioSum})
        }
        data.agioData = agioData;
        let savingData:DataItem[] = [{month:0,value:parseFloat(initialDeposit.toString())}];
        let savingSum = initialDeposit
        for (let index = 0; index < numberOfMonth; index++) {
            let paymentToAdd = monthlySaving;
            savingSum+=paymentToAdd;
            const element = {month:index+1,value:savingSum}
            savingData.push(element);
        }
        
        data.savingsData = savingData;
        let returnsData:DataItem[] = [{month:0,value:parseFloat(initialPerformance.toString())}];
        const monthlyPerformance = (Math.pow((1+percentage/100),1/12)-1)*100
        for (let index = 0; index < numberOfMonth; index++) {
            
            
            
            let prev = 0;
                
            
                    prev = returnsData[index].value;
                
                let brute = (monthlySaving-(monthlySaving/100)*feePerTransaction)+prev;
            
                const returns = brute + (brute/100)*(monthlyPerformance);
            const element = {month:index+1,value:returns}
            returnsData.push(element);
        }
            
        data.returnsData = returnsData;
        return data;
    }
    public static calculateTheInitialSavingsPlan(depot:Depot,agioPercentage:number){
        const startDate = depot.interval_startdate
        const intervalAmount = parseFloat((depot.interval_amount/100).toString());
        let numberOfMonths = moment().diff(moment(startDate),'months');
        const today = moment().date();
        if(today<15 && depot.interval_day==15){
            numberOfMonths--;

        }
        const deposit = intervalAmount*numberOfMonths;
        const agio = ((intervalAmount/100)*agioPercentage)*numberOfMonths;
        return {deposit,agio};

    }
    public static calculateTotalAgio(agioPerTransaction:number,reduction:number,numberOfYears:number,monthlySaving:number):number{
        let totalAgio = ((monthlySaving/100)*agioPerTransaction)*12*numberOfYears;
        totalAgio = totalAgio - (totalAgio/100)*reduction;
        return totalAgio;
    }
    public static calculateNextPossibleDates():NextPossibleDate{
        const today = new Date();
        const day = today.getDate();
        let month = today.getMonth();
        let year = today.getFullYear();
        if (day <= LAST_POSSIBLE_DATE_FOR_HALF) {
            return { nextPossibleDay: 15, nextPossibleMonth:month, nextPossibleYear:year };
        }
        if (month === 11) { // December
            month = 0;
            year++;
        } else {
            month++;
        }
        const nextDay = day <= LAST_POSSIBLE_DATE_FOR_FIRST ? 1 : 15;
        return {nextPossibleDay:nextDay,nextPossibleMonth:month,nextPossibleYear:year}
    }
    public static calculateAgioTableData(monthlySavings:number,totalAgio:number):Array<any>{
        let agioTableData : [] = [];
        let agioPaymentPercentage = AgioPaymentsPercentages.SeventyFive;
       
        let payed = 0;
        let month = 1;
        while(payed<totalAgio)
        {
           
            let rest = totalAgio-payed;
            let element = {}
            const monthlyAgioPayment = (monthlySavings/100)*agioPaymentPercentage
            if(rest>monthlyAgioPayment)
            {
                element = {month:month,saving:monthlySavings,agio:monthlyAgioPayment,assetPurchase:monthlySavings-monthlyAgioPayment};
                payed+=monthlyAgioPayment
            }
            else
            {
                payed+=rest
                element = {month:month,saving:monthlySavings,agio:rest,assetPurchase:monthlySavings-rest};
            }
            agioTableData.push(element);
            month++;
        }
        return agioTableData;
    }
    public static async getIntervalIds():Promise<Array<SavingsPlanPaymentInterval>>{
        const url = this.links.getSavingPlanPaymentInterval();
        const token = TokenService.getToken();
        this.headers.addAuthHeader(token);
        let json = await this.requester.get(url,this.headers);
        let data:SavingsPlanPaymentInterval[] = json.data;
        return data;
    }
    public static async updateDepotAvatar(depotId: number, payload:UpdateDepotRequest):Promise<Depot>{
        try{
            const url = this.links.updateDepotAvatar(depotId);
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.put(url,this.headers, payload);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async updateDepotStatus(depotId: number, payload:UpdateDepotRequest):Promise<Depot>{
        try{
            const url = this.links.updateDepotStatus(depotId);
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.put(url,this.headers, payload);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async detailPaymentAccount(id: number):Promise<PaymentAccount>{
        try{
            const url = this.links.detailPaymentAccount(id);
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.get(url,this.headers);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async getTheListOfPaymentAccounts():Promise<Depot>{
        try{
            const url = this.links.paymentAccounts();
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.get(url,this.headers);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async getTheListOfPaymentMethods():Promise<PaymentMethod>{
        try{
            const url = this.links.paymentMethods();
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.get(url,this.headers);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async updateDepotInfo(depotId: number, payload:UpdateDepotRequest):Promise<Depot>{
        try{
            const url = this.links.updateDepotInfo(depotId);
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.put(url,this.headers, payload);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
    public static async getDepotStatusList():Promise<Depot>{
        try{
            const url = this.links.getDepotStatusList();
            const token = TokenService.getToken();
            this.headers.addAuthHeader(token);
            const json = await this.requester.get(url,this.headers);
            return json.data;
        }
        catch(err){
            throw err;
        }
    }
}